import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import './style.scss';

const renderIcon = (award, day) => {
  const {
    offset,
    status,
    logo,
    logo2,
    logo3
  } = award;
  const className = offset === 7 ? 'final-info-icon' : 'info-icon';
  let icon = logo;
  if (status === 2) {
    if (offset === day) {
      icon = logo3;
    } else {
      icon = logo2;
    }
  }
  return <div className={className} style={{ backgroundImage: `url(${icon})` }} />;
};

const renderStatus = (status) => {
  switch (status) {
    case 0:
      return <span>待领取</span>;
    case 1:
      return <span>点击领取</span>;
    default:
      return <span>已领取</span>;
  }
};

const renderItemInfo = (award, day) => {
  const { status, value } = award;
  return (
    <div className="info">
      {renderIcon(award, day)}
      <div className="info-name">
        {
          status === 2 ? (
            `+${value}`
          ) : (
            `${value}猪猪币`
          )
        }
      </div>
    </div>
  );
};

const renderFinalItemInfo = (award, day) => {
  const { value } = award;
  return (
    <div className="final-info">
      <div className="final-info-text">
        <p>双倍猪猪币</p>
        <p>{value / 2}x2</p>
      </div>
      {renderIcon(award, day)}
    </div>
  );
};

const ZzbList = (
  {
    day, data, large, onClick
  }
) => {
  return (
    <ul
      className={cx('ap-zzb-list', {
        'is-large': large
      })}
    >
      {
        data.map((award) => {
          const {
            offset, status
          } = award;
          const isFinalItem = offset === 7;
          const isActive = offset === day;
          const isFinish = status === 2;
          return (
            <li
              key={offset}
              className={cx('ap-zzb-item', {
                'is-finish': !isActive && isFinish,
                'is-active': isActive
              })}
              onClick={
                () => {
                  onClick(award);
                }
              }
            >
              <p className="day">
                {
                  isActive ? '今天' : `第${offset}天`
                }
              </p>
              {
                isFinalItem ? renderFinalItemInfo(award, day) : renderItemInfo(award, day)
              }
              <div className="status">
                {renderStatus(status)}
              </div>
            </li>
          );
        })
      }
    </ul>
  );
};

ZzbList.propTypes = {
  day: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  onClick: PropTypes.func,
  large: PropTypes.bool
};

export default ZzbList;
